import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const mobitsTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#827850',
    },
    secondary: {
      main: '#1e464b',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#827850',
    },
  },
};
